import { SharedContent } from './shared-content';
export const BeneDetailsContent = {
  pageTitle: `Identify all of the other beneficiaries (except yourself)`,
  pageDescription: `We’ll need the names and birthdates for all the account owner’s children (except you).`,
  grandchildrenPageDescription: `We’ll need the names and birthdates for all the account owner’s grandchildren (except you).`,
  reminder: `<span class="bold">Important reminder:</span> Each beneficiary who you list here will also need to complete this same online process. To make everything as easy as possible for you, we recommend making sure all names and birthdates are exactly the same on all submissions (for example, listing John J. Doe and not simply John Doe).`,
  accordionDescendant: {
    title: `Who should I name on this page?`,
    text: `Because you told us that you're listed as "to my descendants who survive me, per stirpes" on the IRA, please provide names of all the account owner's children. If any of them have passed away, we'll ask if they have children. If they do have children, we'll ask for their names as well (because they'll be entitled to receive assets too).`,
  },
  accordionGrandchild: {
    title: `Who should I name on this page?`,
    text: `Because you told us that you're listed as "to my grandchildren" on the IRA, please provide the names of all the account owner's grandchildren.`,
  },
  familyTreeText: `Family tree example:`,
  continueButton: 'Continue',
  addBeneficiary: '＋ ADD BENEFICIARY',
  removeBeneficiary: '— REMOVE',
  onlyChild: `I am the only child of the account owner`,
  onlyGrandchild: `I am the only grandchild of the account owner`,
  beneDetailsOptions: {
    name: 'Name (first, middle initial, last)',
    invalidError: SharedContent.invalidError,
    requiredError: SharedContent.requiredError,
    dateOfBirth: 'Date of birth (mm/dd/yyyy)',
    dateOfDeath: 'Date of death (mm/dd/yyyy) (if applicable)',
    dodBeforeDobError: 'The date of death cannot be before the date of birth.',
    haveChildren: 'Does this person who passed away have natural or legally adopted children?',
    addChild: '＋ ADD ANOTHER CHILD',
    removeChild: '— REMOVE CHILD',
  },
};
